const createJSON = {
  OrgInfo: {
    OrgPk: "",
    OrgCode: "",
    OrgName: "",
    MapppedOrgCode: "",
    MapppedOrgName: "",
    IsActive: "1",
    IsConsignee: "",
    IsConsignor: "",
    IsForwarder: "",
    IsShippingLine: "",
    ShippingSacCode: "",
  },
  Addresses: [
    {
      AddressPk: "",
      AddressFk: "",
      Address1: "",
      City: "",
      Address2: "",
      Country: "",
      PostCode: "",
      State: "",
      PortCode: "",
      IsActive: "",
    },
  ],
  Contacts: [
    {
      ContactPk: "",
      ContactFk: "",
      ContactName: "",
      Email: "",
      IsWebEnable: "",
      jobTitle: "",
      Designation: "",
      IsActive: "",
    },
  ],
  BuyerCollection: [
    {
      BuyerPk: "",
      BuyerFk: "",
      BuyerSupplierFk: "",
      BuyerCode: "",
      BuyerName: "",
      isBuyer: "",
    },
  ],
  SupplierCollection: [
    {
      SupplierPk: "",
      SupplierFk: "",
      SupplierBuyerFk: "",
      SupplierCode: "",
      SupplierName: "",
      isSupplier: "",
    },
  ],
  AgentCollection: [
    {
      AgentPk: "",
      AgentFK: "",
      AgentParentFK: "",
      AgentCode: "",
      AgentParentCode: "",
      AgentType: "",
    },
  ],
};

export { createJSON };
